import React, { useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Loader2 } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../../ui/dialog';
import { Button } from '../../ui/button';
import { Textarea } from '../../ui/textarea';
import { erroreHaccp } from '../haccpApi';

// Testo obbligatorio (motivo, esito, nota): resta scritto nel registro del richiamo
export const TestoDialog = ({ open, titolo, descrizione, segnaposto, bottone, testid, onConferma, onClose }) => {
  const [testo, setTesto] = useState('');
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) setTesto(''); }, [open]);

  const conferma = async () => {
    setBusy(true);
    try {
      await onConferma(testo.trim());
      onClose();
    } catch (e) {
      toast.error(erroreHaccp(e, 'Operazione non riuscita'));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid={`${testid}-dialog`}>
        <DialogHeader>
          <DialogTitle>{titolo}</DialogTitle>
          <DialogDescription>{descrizione}</DialogDescription>
        </DialogHeader>
        <Textarea value={testo} onChange={(e) => setTesto(e.target.value)} rows={3} placeholder={segnaposto} data-testid={`${testid}-testo`} />
        <div className="flex gap-2 justify-end">
          <Button variant="outline" onClick={onClose} data-testid={`${testid}-indietro`}>Indietro</Button>
          <Button onClick={conferma} disabled={busy || testo.trim().length < 3} className="bg-gray-900 hover:bg-gray-800 text-white"
            data-testid={`${testid}-conferma`}>
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : bottone}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
